import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Youtube, Facebook, Heart, Accessibility } from "lucide-react";
import { NewsletterForm } from "./NewsletterForm";

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground mt-20">
      {/* Banner 5x1000 — elemento distintivo dal sito originale fiaba.org */}
      <div className="bg-gold text-secondary-foreground">
        <div className="container py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Heart className="w-8 h-8 shrink-0" aria-hidden="true" />
            <div>
              <p className="font-serif text-lg font-bold leading-tight">Dona il tuo 5×1000 a FIABA ETS</p>
              <p className="text-sm opacity-90">È gratis. Sostieni 25 anni di battaglie per l'accessibilità.</p>
            </div>
          </div>
          <div className="bg-secondary-foreground/10 border border-secondary-foreground/20 rounded-md px-5 py-3 text-center">
            <p className="text-xs uppercase tracking-widest font-semibold">Codice Fiscale</p>
            <p className="font-mono text-xl font-bold tracking-wider">97240590584</p>
          </div>
        </div>
      </div>

      <div className="container py-16 grid gap-10 md:grid-cols-5">
        <div className="md:col-span-2">
          <h3 className="font-serif text-2xl font-bold mb-3">FIABA ETS</h3>
          <p className="text-primary-foreground/80 text-sm leading-relaxed max-w-md">
            Fondo Italiano per l'Abbattimento delle Barriere Architettoniche.
            Ente del Terzo Settore. Da oltre 25 anni promuoviamo accessibilità,
            inclusione e Universal Design in Italia.
          </p>
          <div className="flex gap-3 mt-5">
            <a
              href="https://www.facebook.com/FIABAONLUS/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="FIABA su Facebook"
              className="p-2 rounded-full bg-primary-foreground/10 hover:bg-secondary hover:text-secondary-foreground transition-colors"
            >
              <Facebook size={18} aria-hidden="true" />
            </a>
            <a
              href="https://www.youtube.com/@FiabaONLUS"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Canale YouTube ufficiale FIABA"
              className="p-2 rounded-full bg-primary-foreground/10 hover:bg-secondary hover:text-secondary-foreground transition-colors"
            >
              <Youtube size={18} aria-hidden="true" />
            </a>
            <a
              href="https://whatsapp.com/channel/0029Vai9pUWHQbSAF2h4BT0G"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Canale WhatsApp ufficiale FIABA"
              className="p-2 rounded-full bg-primary-foreground/10 hover:bg-secondary hover:text-secondary-foreground transition-colors"
            >
              {/* WhatsApp glyph (lucide non lo include) */}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-secondary">Naviga</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/chi-siamo" className="hover:text-secondary">Chi siamo</Link></li>
            <li><Link to="/area-tecnica" className="hover:text-secondary">Area Tecnica</Link></li>
            <li><Link to="/servizi-comuni" className="hover:text-secondary">Servizi Comuni</Link></li>
            <li><Link to="/servizi-aziende" className="hover:text-secondary">Servizi Aziende</Link></li>
            <li><Link to="/fiaba-day" className="hover:text-secondary">FIABA Day</Link></li>
            <li><Link to="/segnalazioni" className="hover:text-secondary">Segnalazioni</Link></li>
            <li><Link to="/diventa-socio" className="hover:text-secondary">Diventa socio</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-secondary">Contatti</h4>
          <ul className="space-y-3 text-sm text-primary-foreground/90">
            <li className="flex gap-2 items-start"><MapPin size={16} className="mt-0.5 shrink-0" /><span>Piazzale degli Archivi, 41<br/>00144 Roma RM</span></li>
            <li className="flex gap-2 items-center"><Phone size={16} /><a href="tel:+390643400800" className="hover:text-secondary">06 43400800</a></li>
            <li className="flex gap-2 items-center"><Mail size={16} /><a href="mailto:segreteria@fiaba.org" className="hover:text-secondary">segreteria@fiaba.org</a></li>
          </ul>
        </div>

        <div>
          <NewsletterForm />
        </div>
      </div>

      <div className="border-t border-primary-foreground/10">
        <div className="container py-5 flex flex-col md:flex-row md:items-center justify-between gap-3 text-xs text-primary-foreground/70">
          <p>© {new Date().getFullYear()} FIABA ETS — RUNTS G14936/2023 — C.F. 97240590584</p>
          <nav aria-label="Note legali" className="flex flex-wrap gap-x-4 gap-y-1">
            <a
              href="https://www.iubenda.com/privacy-policy/85586417"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-secondary"
            >
              Privacy policy
            </a>
            <a
              href="https://www.iubenda.com/privacy-policy/85586417/cookie-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-secondary"
            >
              Cookie policy
            </a>
            <a
              href="https://www.accessiway.com/it/home/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-secondary inline-flex items-center gap-1"
              aria-label="AccessiWay — soluzione di accessibilità web"
            >
              <Accessibility size={13} aria-hidden="true" />
              AccessiWay
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};
